import React, { Component } from "react";
import PropTypes from "prop-types";

class Sidebar extends Component {
  render() {
    const { children } = this.props;
    return (
      <div
        className="collections__sidebar collections__sidebar--width-md d-none col-auto d-lg-block"
        data-sticky-sidebar-parent
      >
        <div className="js-sticky-sidebar">
          <div data-js-position-desktop="sidebar" >
            <div
              id="theme-section-collection-sidebar"
              className="theme-section"
            >
              <div
                data-section-type="collection-sidebar"
              >
                <aside
                  className="collection-sidebar js-position js-collection-sidebar"
                >
                  <nav className="collection-sidebar__navigation">
                    {children}
                  </nav>
                </aside>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Sidebar.propTypes = {};

export default Sidebar;
